module.exports = __webpack_public_path__ + "static/top-banner-op-image-202acee77de539edf05b72f297a917b6.png";